import { FC, memo, useCallback, useMemo, useRef } from 'react';

import { translate } from '../../../i18n';
import { getActiveRoute } from '../../../utils/navigationService';
import { RouteName } from '../../../utils/routes/routesConfig';
import GeneralMobileWebHeader, {
  GeneralHeaderRight,
  RenderRight,
} from '../../GeneralMobileWebHeader';
import { Props } from './types';

const Header: FC<Props> = ({ logEvent }) => {
  const headerRef = useRef<GeneralMobileWebHeader | null>(null);
  const { routeName } =
    useMemo<{ routeName?: RouteName }>(getActiveRoute, []) || {};

  const renderRight: RenderRight = useCallback(args => {
    return (
      <GeneralHeaderRight {...args} headerRef={headerRef} location="購物車" />
    );
  }, []);

  // Don't show web header if is stackcart
  if (routeName === 'CartPage') {
    return null;
  }

  return (
    <GeneralMobileWebHeader
      ref={headerRef}
      headerTitle={translate('cart')}
      logEvent={logEvent}
      renderRight={renderRight}
    />
  );
};

export default memo(Header);
